export default __webpack_public_path__ + "static/media/arrow-left.f3619997.svg";